import React from 'react'

const CONTACT_DETAIL_BULLET = ' • '

type ContactDetailLineProps = {
  parts: string[]
  className?: string
}

/**
 * Centered contact row. Separator stays with the previous segment; on wrap the last
 * two segments move together (e.g. "substack • github"), never a lone " • github".
 */
export default function ContactDetailLine({ parts, className = '' }: ContactDetailLineProps) {
  if (parts.length === 0) return null

  if (parts.length === 1) {
    return (
      <div className={`contact-detail-line text-center ${className}`.trim()}>
        <span className="contact-detail-item">{parts[0]}</span>
      </div>
    )
  }

  const head = parts.slice(0, -2)
  const penultimate = parts[parts.length - 2]
  const last = parts[parts.length - 1]

  return (
    <div className={`contact-detail-line text-center ${className}`.trim()}>
      {head.map((part, index) => (
        <React.Fragment key={`head-${index}-${part}`}>
          {index > 0 && <span className="contact-detail-bullet">{CONTACT_DETAIL_BULLET}</span>}
          <span className="contact-detail-item">{part}</span>
        </React.Fragment>
      ))}
      {head.length > 0 && <span className="contact-detail-bullet">{CONTACT_DETAIL_BULLET}</span>}
      <wbr />
      <span className="contact-detail-tail inline-block whitespace-nowrap">
        <span className="contact-detail-item">{penultimate}</span>
        <span className="contact-detail-bullet">{CONTACT_DETAIL_BULLET}</span>
        <span className="contact-detail-item">{last}</span>
      </span>
    </div>
  )
}
